import { Field, useField } from "formik";

export default function Input({ label, required = false, ...props }) {
  const [field, meta] = useField(props);

  return (
    <div>
      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
        {label}
        {required && <span className="text-red-500 mr-1">*</span>}
      </label>
      <input
        {...field}
        {...props}
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
      />
      {meta.touched && meta.error ? (
        <p className="text-sm my-4 text-red-500 dark:text-red-400">
          {meta.error}
        </p>
      ) : null}
    </div>
  );
}